import clsx from 'clsx';
import React from 'react';

import LockedLeadCaptureForm from '@components/LockedLeadCaptureForm';
import { Env } from '@contexts/AppContext';
import { create_user_path, subscribe_path } from '@routes';
import { getImgxSrc } from '@utils/images';

import styles from './styles.module.scss';

const Logos = [
  'Bain.png',
  'Spotify.png',
  'Goldman.png',
  'Upenn.png',
  'Meta.png',
  'Morgan.png',
  'Amazon.png',
  'Netflix.png',
  'Google.png',
  'Accenture.png',
  'Uber.png',
  'Stanford.png',
  'Columbia.png',
  'Harvard.png',
  'Microsoft.png',
];

const LayOut = ({ gdpr, env }: { gdpr: boolean; env: Env }) => {
  return (
    <div className="org-signup container">
      <div className={clsx(styles.emailContainer, 'row')}>
        <div className={clsx(styles.emailWrapper, 'col-sm-12 col-md-9')}>
          <div className={clsx(styles.topRibbon)} />
          <div className={styles.header}>Sign up via your school or company</div>
          <div className={styles.subheader}>Your organization email</div>
          <LockedLeadCaptureForm
            buttonText="Validate email"
            colorScheme="light"
            endpointUri={create_user_path()}
            formLocation="org_signup"
            isGdprLead={gdpr}
            leadType="org_email_domain"
            redirectUri={subscribe_path()}
          />
        </div>
      </div>
      <div className={clsx(styles.logosContainer)}>
        {Logos.map((imgPath) => (
          <div key={imgPath} className={styles.imageContainer}>
            <img
              className={styles.image}
              src={getImgxSrc({
                path: `logo-image-url/${imgPath}`,
                isDevDependence: false,
                envContext: env,
              })}
              alt={`${imgPath.replace('.png', '')} icon`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LayOut;
